import { render, staticRenderFns } from "./dragpicture.vue?vue&type=template&id=0e495890&scoped=true"
import script from "./dragpicture.vue?vue&type=script&lang=js"
export * from "./dragpicture.vue?vue&type=script&lang=js"
import style0 from "./dragpicture.vue?vue&type=style&index=0&id=0e495890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e495890",
  null
  
)

export default component.exports